import { createSlice } from '@reduxjs/toolkit';
import { CardSetPublic } from '../../models/Game';

interface CardSetSlice {
  sets: CardSetPublic[];
}

const initialState: CardSetSlice = {
  sets: [],
}

const cardSetSlice = createSlice({
  name: 'cardSet',
  initialState,
  reducers: {
    receiveCardSets: ((state, data) => {
      state.sets = data.payload.sets;
    })
  },
});

export const cardSetActions = cardSetSlice.actions;
export default cardSetSlice.reducer;